var voted_users_rtlignore_default = {
  "container": "AyLnF",
  "webview": "JE2AD",
  "avatar_list": "pleYT",
  "avatar": "_17q6x",
  "user_avatar": "AhUS0",
  "modal": "ipwyo",
  "voted_users_modal": "yYYYt",
  "overlay": "WM6Dc",
  "user_card": "YIowJ",
  "user_name": "ezkwW",
  "voted_users_modal_header": "r4e0M",
  "cta": "NWVmp",
  "close_icon": "fGn4-",
  "title": "yBp-2",
  "member_list_container": "_5D0xA",
  "member_list": "Qlkdg",
  "loader": "_1J90X",
  "anonymous_counter": "_3HbUT",
  "spinner": "_2hDLX",
  "spin": "LdCeC"
};
export {
  voted_users_rtlignore_default as default
};
//# sourceMappingURL=voted-users.rtlignore-scss.js.map
